import styled from '@emotion/styled';
import Paper from '@base/Paper/Paper';
import Skeleton from '@material-ui/lab/Skeleton';
import HeaderNavBar from '../HeaderNavBar/HeaderNavBar';

const Container = styled(Paper)`
  grid-column: span 24 / auto;
  padding: 32px 48px;
`;

const Header = styled(HeaderNavBar)`
  padding: 0;
`;

const Content = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
`;

const Thumbnail = styled(Skeleton)`
  box-sizing: border-box;
  margin-right: 32px;
  border-radius: 8px;
  transform: scale(1);
`;

// eslint-disable-next-line react/jsx-props-no-spreading
const RectSkeleton = (props) => <Skeleton variant="rect" {...props} />;

const Language = styled(RectSkeleton)`
  margin-bottom: 8px;
`;

const Title = styled(RectSkeleton)`
  margin-bottom: 4px;
`;

const ShortDescription = styled(RectSkeleton)`
  margin-top: 32px;
`;

const Description = styled.div`
  display: flex;
  flex-direction: column;
`;
const Line = styled(RectSkeleton)`
  margin-top: 4px;
`;
const Buttons = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const Subscribe = styled(RectSkeleton)`
  width: 164px;
  height: 46px;
  margin-bottom: 8px;
`;
const Share = styled(Subscribe)`
  margin-bottom: 0;
`;

export default function PlusHeader() {
  return (
    <Container>
      <Header title={false} breadcrumbsCount={4} />
      <Content>
        <Thumbnail width={360} height={180} />
        <Description>
          <Language width={80} height={30} />
          <Title width={300} height={20} />
          <ShortDescription width={420} height={20} />
          <Line width={420} height={20} />
        </Description>
        <Buttons>
          <Subscribe />
          <Share />
        </Buttons>
      </Content>
    </Container>
  );
}
